// The upload pipeline (audio + visual transcription) runs in one of five functions that differ only in
// memory, because the whole video is processed in the function's /tmp. Pick by file size, one step up
// for long videos. Used by Studio and workspace uploads and by Studio's Reprocess.
import { getFunctions, httpsCallable } from 'firebase/functions';

const GB = 1024 ** 3;
const LONG_VIDEO_SECONDS = 5400; // 1.5 hours

const TIERS = [
  { name: 'getCaptionsBump2GB',  timeout: 600000,  maxShort: 0.5 * GB, maxLong: 0 },
  { name: 'getCaptionsBump4GB',  timeout: 600000,  maxShort: 1.5 * GB, maxLong: 0.5 * GB },
  { name: 'getCaptionsBump8GB',  timeout: 600000,  maxShort: 3.5 * GB, maxLong: 1.5 * GB },
  { name: 'getCaptionsBump16GB', timeout: 900000,  maxShort: 7.5 * GB, maxLong: 3.5 * GB },
  { name: 'getCaptionsBump32GB', timeout: 1200000, maxShort: Infinity, maxLong: Infinity },
];

export const captionsBumpFunctionFor = (sizeBytes, durationSeconds) => {
  const isLong = durationSeconds > LONG_VIDEO_SECONDS;
  const tier = TIERS.find(t => sizeBytes <= (isLong ? t.maxLong : t.maxShort));
  return httpsCallable(getFunctions(), tier.name, { timeout: tier.timeout });
};
